import { z } from 'zod';

export const CustomerHitSchema = z.object({
    id: z.number(),
    externalId: z.string(),
    isCompany: z.boolean(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    identificationNumber: z.string(),
    phone: z.string(),
});

export const emptyCustomerHitObject: CustomerHit = {
    id: 0,
    externalId: "",
    isCompany: false,
    firstName: "",
    lastName: "",
    identificationNumber: "",
    phone: "",
};

export type CustomerHit = z.infer<typeof CustomerHitSchema>;